const warm = {
    '0': '#FFFFFF',
    '25': '#FBF9F8',
    '50': '#F8F6F4',
    '75': '#F0ECE8',
    '100': '#E7E2DD',
    '200': '#D6D0C9',
    '300': '#BEB8B0',
    '400': '#ACA59E',
    '500': '#948E87',
    '600': '#857F79',
    '700': '#67625D',
    '800': '#4F4B47',
    '900': '#3C3935',
    '1000': '#181613',
};
const gray = warm;
const blue = {
    '50': '#EBF1FF',
    '100': '#C4D7FF',
    '200': '#99BAFF',
    '300': '#5C90FF',
    '400': '#2E6DFF',
    '500': '#0B4EF5',
    '600': '#0040D6',
    '700': '#0F3AA8',
    '800': '#0B2C7D',
    '900': '#071F57',
};
const indigo = {
    '50': '#F0EEFF',
    '100': '#DBD4FF',
    '200': '#C0B2FF',
    '300': '#9C82FF',
    '400': '#7B54FF',
    '500': '#5B23FF',
    '600': '#4A11E6',
    '700': '#3D14B8',
    '800': '#2E1189',
    '900': '#1F0C61',
};
const purple = {
    '50': '#FAEDFF',
    '100': '#F0CFFF',
    '200': '#E4A9FF',
    '300': '#D172FF',
    '400': '#C044FF',
    '500': '#A711F5',
    '600': '#8F00DC',
    '700': '#7411B0',
    '800': '#570D84',
    '900': '#3C085C',
};
const magenta = {
    '50': '#FFEBF5',
    '100': '#FFC7E4',
    '200': '#FF9BD0',
    '300': '#FF5CB2',
    '400': '#FF2A9D',
    '500': '#F5008A',
    '600': '#D6007A',
    '700': '#A80862',
    '800': '#7D0849',
    '900': '#560533',
};
const red = {
    '50': '#FFEDEA',
    '100': '#FFCBC2',
    '200': '#FFA192',
    '300': '#FF6650',
    '400': '#FF3A1F',
    '500': '#F01500',
    '600': '#CE1000',
    '700': '#A11409',
    '800': '#781007',
    '900': '#530A04',
};
const orange = {
    '50': '#FFF3E6',
    '100': '#FFDCB8',
    '200': '#FFC186',
    '300': '#FF9B33',
    '400': '#FF7D00',
    '500': '#FA6400',
    '600': '#DB5200',
    '700': '#AB4406',
    '800': '#7F3204',
    '900': '#582302',
};
const brown = {
    '50': '#F7F4F1',
    '100': '#EBE5DE',
    '200': '#E0D6CA',
    '300': '#D3C5B4',
    '400': '#C3B19A',
    '500': '#B29A7D',
    '600': '#A38664',
    '700': '#826A4D',
    '800': '#6F5A42',
    '900': '#554532',
};
const yellow = {
    '50': '#FFFCD4',
    '100': '#FFF68F',
    '200': '#FFEE45',
    '300': '#FFE100',
    '400': '#FFD000',
    '500': '#F7BE00',
    '600': '#DBA500',
    '700': '#A88000',
    '800': '#7D5F00',
    '900': '#574100',
};
const green = {
    '50': '#E3FCE9',
    '100': '#B0F5C1',
    '200': '#74EA96',
    '300': '#22D662',
    '400': '#00C24C',
    '500': '#00A93F',
    '600': '#009235',
    '700': '#08742D',
    '800': '#055623',
    '900': '#033D18',
};
const teal = {
    '50': '#DCFAF3',
    '100': '#9FF2DF',
    '200': '#5FE7CB',
    '300': '#00D0AC',
    '400': '#00BC98',
    '500': '#009E80',
    '600': '#00876D',
    '700': '#076A56',
    '800': '#054F41',
    '900': '#03392F',
};
const cyan = {
    '50': '#E2F8FF',
    '100': '#A8EAFF',
    '200': '#66D8FF',
    '300': '#00BEF5',
    '400': '#00A6E0',
    '500': '#008CC2',
    '600': '#0079A8',
    '700': '#0A5E80',
    '800': '#074860',
    '900': '#043445',
};
export const swatches = {
    warm,
    gray,
    blue,
    indigo,
    purple,
    magenta,
    red,
    orange,
    brown,
    yellow,
    green,
    teal,
    cyan,
};
